export default "__VITE_ASSET__12f27f3b__"